import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactForm extends EventRegistryCategory {
    label = 'Form Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    change = () => new EventRegistryItem({ handlerName: 'onChange' });
    input = () => new EventRegistryItem({ handlerName: 'onInput' });
    invalid = () => new EventRegistryItem({ handlerName: 'onInvalid' });
    submit = () => new EventRegistryItem({ handlerName: 'onSubmit' });
}
